// document.addEventListener('DOMContentLoaded', function() {
//     function CustomSlideoutDrawer() {
//         const summaries = document.querySelectorAll('[id^="Trigger-"]');

//         summaries.forEach(summary => {
//             summary.addEventListener('click', function() {
//                 console.log('Trigger clicked');
//                 const drawerId = this.getAttribute('id').replace('Trigger-', '');
//                 const drawerContainer = document.getElementById(`Container-${drawerId}`);
//                 const drawerInfo = document.getElementById(`Info-${drawerId}`);

//                 drawerInfo.classList.toggle('open');
//                 drawerContainer.classList.toggle('open');

//                 // Toggle overflow-hidden class on body
//                 document.body.classList.toggle('overflow-hidden');
//             });
//         });

//         const closeTriggers = document.querySelectorAll('[data-custom-slideout-drawer-close]');
//         closeTriggers.forEach(trigger => {
//             trigger.addEventListener('click', function() {
//                 console.log('Close trigger clicked');
//                 const drawerInfo = document.querySelector('.custom-slideout-drawer.open');
//                 const drawerContainer = document.querySelector('.custom-slideout-drawer-container.open');

//                 drawerInfo.classList.remove('open');
//                 drawerContainer.classList.remove('open');

//                 document.body.classList.remove('overflow-hidden');
//             });
//         });
//     }

//     CustomSlideoutDrawer();
// });

document.addEventListener('DOMContentLoaded', function() {
    function CustomSlideoutDrawer() {
        // Trigger open slideout
        const triggers = document.querySelectorAll('[data-slideout-trigger]');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', function() {
                const slideoutId = this.getAttribute('data-slideout-trigger');
                const drawerContainer = document.querySelector(`[data-slideout-id="${slideoutId}"] .custom-slideout-drawer-container`);
                const drawer = document.querySelector(`[data-slideout-id="${slideoutId}"] .custom-slideout-drawer`);

                if (drawerContainer && drawer) {
                    console.log('Opening drawer:', slideoutId);
                    drawer.classList.toggle('open');
                    drawerContainer.classList.toggle('open');
                    document.body.classList.toggle('overflow-hidden');
                }
            });
        });

        // Close triggers
        const closeTriggers = document.querySelectorAll('[data-custom-slideout-drawer-close]');
        closeTriggers.forEach(trigger => {
            trigger.addEventListener('click', function() {
                console.log('Close trigger clicked');
                const openDrawers = document.querySelectorAll('.custom-slideout-drawer.open');
                const openContainers = document.querySelectorAll('.custom-slideout-drawer-container.open');

                openDrawers.forEach(drawer => {
                    drawer.classList.remove('open');
                });
                openContainers.forEach(container => {
                    container.classList.remove('open');
                });
                document.body.classList.remove('overflow-hidden');
            });
        });
    }

    CustomSlideoutDrawer();
});
